export const LIFECYCLE_PATHS = {
  ats: '/erp/applicant-tracking-system',
  atsOffers: '/erp/applicant-tracking-system/offer-letters',
  atsProbation: '/erp/applicant-tracking-system/probation-letters',
  employees: '/erp/employee-management',
  deployments: '/erp/employee-deployment-management',
  exitLetters: '/erp/applicant-tracking-system',
};

export function atsWithStatus(status) {
  return `${LIFECYCLE_PATHS.ats}?status=${encodeURIComponent(status)}`;
}

export function atsWithApplicant(applicantId) {
  return `${LIFECYCLE_PATHS.ats}?applicantId=${encodeURIComponent(applicantId)}`;
}

export function auditEntityPath(row) {
  if (!row?.entity_type || !row?.entity_id) return null;
  switch (row.entity_type) {
    case 'job_application':
      return atsWithApplicant(row.entity_id);
    case 'employee':
      return `${LIFECYCLE_PATHS.employees}?employeeId=${encodeURIComponent(row.entity_id)}`;
    case 'offer_letter':
      return LIFECYCLE_PATHS.atsOffers;
    default:
      return null;
  }
}

export const ACTION_TYPE_STYLES = {
  deployment_required: { dot: 'bg-amber-500', badge: 'bg-amber-100 text-amber-800' },
  offer_pending: { dot: 'bg-blue-500', badge: 'bg-blue-100 text-blue-800' },
  ready_to_hire: { dot: 'bg-green-500', badge: 'bg-green-100 text-green-800' },
  onboarding_incomplete: { dot: 'bg-purple-500', badge: 'bg-purple-100 text-purple-800' },
};

export const ACTION_TYPE_LABELS = {
  deployment_required: 'Deploy',
  offer_pending: 'Offer',
  ready_to_hire: 'Hire',
  onboarding_incomplete: 'Onboard',
};

export const STAGE_LABELS = {
  pending: 'Pending',
  screening: 'Screening',
  interview: 'Interview',
  selected: 'Selected',
  offer: 'Offer',
  hired: 'Hired',
  deployed: 'Deployed',
  rejected: 'Rejected',
};

export const FUNNEL_STAGE_COLORS = {
  pending: 'bg-slate-400',
  screening: 'bg-slate-500',
  interview: 'bg-indigo-400',
  selected: 'bg-indigo-500',
  offer: 'bg-violet-500',
  hired: 'bg-emerald-500',
  deployed: 'bg-emerald-600',
};
